import { InjectionToken } from '@angular/core';
import { TShopAd } from '@x/ecommerce/shop-client';
import { Observable } from 'rxjs';

export type TAdPlacement = 'V_BANNER' | 'H_BANNER' | 'CARD';

export const AD_CONFIG = new InjectionToken<IAdConfig>('AD_CONFIG');

export interface IAdGlobalFilters {
  taxonPath: string;
  regionId: number | undefined | null;
  loggedIn: boolean;
}

export interface IAdConfig {
  globalFilters$: Observable<IAdGlobalFilters>;
  ads$: Observable<TShopAd[]>;
}
